import { findElementByPropertyValue } from './collection-utils';

export const findLangByCode = (languages, code) =>
  findElementByPropertyValue(languages, 'code', code);
